import { render, staticRenderFns } from "./CourseInvoiceBasisDetailsPage.vue?vue&type=template&id=5bf3b60f&"
import script from "./CourseInvoiceBasisDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./CourseInvoiceBasisDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseInvoiceBasisDetailsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VTooltip})
